import React, { useState } from 'react';
import { FileText, Plus } from 'lucide-react';
import API from '../api/axios';
import toast from 'react-hot-toast';

const CreatePostModal = ({ groupId, onClose, onSuccess }) => {
  const [form, setForm] = useState({ title: '', details: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title || !form.details) { toast.error('العنوان والتفاصيل مطلوبان'); return; }
    setLoading(true);
    try {
      await API.post('/posts', { groupId, ...form });
      toast.success('تم إضافة البوست 📝');
      onSuccess();
    } catch (err) {
      toast.error(err.response?.data?.message || 'فشل الإضافة');
    } finally { setLoading(false); }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title"><FileText size={18} style={{ display: 'inline', marginLeft: '8px' }} />إضافة بوست جديد</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">عنوان البوست *</label>
            <input type="text" className="form-input" placeholder="اكتب عنوان البوست"
              value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} />
          </div>
          <div className="form-group">
            <label className="form-label">التفاصيل *</label>
            <textarea className="form-textarea" placeholder="اكتب تفاصيل البوست هنا..." rows={5}
              value={form.details} onChange={e => setForm({ ...form, details: e.target.value })} />
          </div>
          <div style={{ display: 'flex', gap: '10px', marginTop: '8px' }}>
            <button type="button" className="btn btn-secondary" style={{ flex: 1 }} onClick={onClose}>إلغاء</button>
            <button type="submit" className="btn btn-primary" style={{ flex: 2 }} disabled={loading}>
              {loading ? <div className="spinner spinner-sm" /> : <Plus size={16} />}
              {loading ? 'جاري الإضافة...' : 'إضافة البوست'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreatePostModal;
